<template>
  <div>
    <p class="crm-kicker">Kanban stand</p>
    <h1 class="crm-title">Pipeline</h1>
    <p class="crm-hint">Uniquement les contacts saisis au stand — pas l’import Monday / webinaire</p>
    <div v-if="loading" class="crm-hint">Chargement…</div>
    <div v-else class="crm-kanban">
      <div class="crm-kanban-col" v-for="col in columns" :key="col">
        <h4>{{ col }} ({{ byPipeline[col].length }})</h4>
        <div
          v-for="h in byPipeline[col]"
          :key="h.id"
          class="crm-kanban-item"
          @click="openFiche(h.id)"
          style="cursor:pointer"
        >
          <strong>{{ display(h) }}</strong>
          <div class="crm-meta">{{ h.societe }}</div>
          <select
            class="crm-select"
            style="min-height:36px;margin-top:8px;font-size:12px"
            :value="h.pipeline"
            @click.stop
            @change="move(h, $event.target.value)"
          >
            <option v-for="p in columns" :key="p" :value="p">{{ p }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PIPELINES, displayName, withFrom } from './crmSalonUtils'
export default {
  name: 'CrmSalonPipeline',
  data() {
    return { columns: PIPELINES, hits: [], loading: false }
  },
  computed: {
    byPipeline() {
      const map = {}
      this.columns.forEach(c => { map[c] = [] })
      this.hits.forEach(h => {
        const p = h.pipeline || 'Nouveau'
        if (!map[p]) map[p] = []
        map[p].push(h)
      })
      return map
    }
  },
  mounted() { this.load() },
  methods: {
    display: displayName,
    openFiche(id) {
      this.$router.push(withFrom('/crm-salon/fiche/' + id, this.$route.fullPath))
    },
    async load() {
      this.loading = true
      const all = []
      let page = 1
      let last = 1
      try {
        do {
          const { data } = await this.$apollo.query({
            client: 'AUTH',
            query: require('src/graphql/auth/crmSalon/crmSalonCarnet.gql'),
            variables: { page, per_page: 50, salon_only: true },
            fetchPolicy: 'network-only'
          })
          const block = data.crmSalonCarnet || {}
          all.push.apply(all, block.items || [])
          last = Number(block.last_page) || 1
          page++
        } while (page <= last && all.length < 300)
        this.hits = all
      } finally {
        this.loading = false
      }
    },
    async move(h, pipeline) {
      try {
        await this.$apollo.mutate({
          client: 'AUTH',
          mutation: require('src/graphql/auth/crmSalon/crmSalonSetPipeline.gql'),
          variables: { prospect_id: String(h.id), pipeline }
        })
        h.pipeline = pipeline
      } catch (e) {}
    }
  }
}
</script>
